import { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Container,
  Divider,
  Grid,
  Icon,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { useAuthHeader } from "react-auth-kit";
import {
  Engineering,
  Event,
  MonitorHeart,
  People,
  AddLink,
  VideoCall,
} from "@mui/icons-material";
import "./Counters.css";
import { LoadingPaper, LoadingError } from "../LoadingComponents";
import { useQuery } from "react-query";
import axiosInstance from "../../utils/AxiosInstance";
import { toast } from "react-toastify";
import Counter from "./Counter";

const colors = {
  red: "#dd4b39",
  green: "#00a65a",
  yellow: "#f39c12",
  lightblue: "#39cccc",
  violet: "#a348a3",
  transparent: "#FFFFFF",
};

const countersPretty = {
  active_users: {
    label: "PAZIENTI ATTIVI",
    icon: <People fontSize="large" />,
    backgroundColor: colors.green,
    value: 0,
    navigateTo: "/patients", // TODO: add filter to url ?active=true
    filter: {
      is_active: "true",
    },
  },
  active_doctors: {
    label: "PROFESSIONISTI SANITARI ATTIVI",
    icon: <Engineering fontSize="large" />,
    backgroundColor: colors.green,
    value: 0,
    navigateTo: "/doctors",
    filter: {
      is_active: "true",
    },
  },
  n_services: {
    label: "TELEMONITORAGGI ATTIVI",
    icon: <MonitorHeart fontSize="large" />,
    backgroundColor: colors.green,
    value: 0,
    navigateTo: "/telemonitoraggi",
    filter: {
      is_active: "true",
    },
  },
  inactive_users: {
    label: "PAZIENTI NON ATTIVI",
    icon: <People fontSize="large" />,
    backgroundColor: colors.yellow,
    value: 0,
    navigateTo: "/patients", // TODO: add filter to url ?active=false
    filter: {
      is_active: "false",
    },
  },
  inactive_doctors: {
    label: "PROFESSIONISTI SANITARI INATTIVI",
    icon: <Engineering fontSize="large" />,
    backgroundColor: colors.yellow,
    value: 0,
    navigateTo: "/doctors",
    filter: {
      is_active: "false",
    },
  },
  monitoring_to_activate: {
    label: "TELEMONITORAGGI DA ATTIVARE",
    icon: <AddLink fontSize="large" />,
    backgroundColor: colors.red,
    value: 0,
    navigateTo: "/controlroom",
    filter: null,
  },
  n_gg_monitoring: {
    label: "NUMERO GIORNI MONITORAGGIO",
    icon: <Event fontSize="large" />,
    backgroundColor: colors.lightblue,
    value: 0,
    navigateTo: "/telemonitoraggi",
    filter: null,
  },
  n_mon_expiring: {
    label: "TELEMONITORAGGI IN SCADENZA",
    icon: <MonitorHeart fontSize="large" />,
    backgroundColor: colors.red,
    value: 0,
    navigateTo: "/telemonitoraggi",
    filter: null,
  },
  n_televisits: {
    label: "NUMERO TELEVISITE",
    icon: <VideoCall fontSize="large" />,
    backgroundColor: colors.violet,
    value: 0,
    navigateTo: "/televisite",
    filter: null,
  },
};

function Counters() {
  // === authentication ===
  const authHeader = useAuthHeader();

  // === web service querying ===
  const countersQuery = useQuery(["counters"], async () => {
    const res = await axiosInstance.get(`/counters`, {
      headers: { Authorization: authHeader() },
    });

    const data = res.data;

    const countersLabels = Object.keys(countersPretty);
    for (let counter of countersLabels) {
      countersPretty[counter].value = data[counter];
    }

    return data;
  });

  if (countersQuery.isError)
    console.log("Error downloading countersQuery.data.");

  return (
    <>
      {countersQuery.isLoading ? (
        <LoadingPaper />
      ) : countersQuery.isError ? (
        <LoadingError error={countersQuery.error} />
      ) : (
        <Paper
          variant="outlined"
          style={{
            margin: "3vh",
            maxWidth: "90%",
            margin: "auto",
            alignContent: "center",
          }}
        >
          <Grid container>
            {Object.keys(countersPretty).map((counter) => (
              <Counter
                key={counter}
                backgroundColor={countersPretty[counter].backgroundColor}
                icon={countersPretty[counter].icon}
                label={countersPretty[counter].label}
                value={countersPretty[counter].value}
                navigateTo={countersPretty[counter].navigateTo}
                filter={countersPretty[counter].filter}
              />
            ))}
          </Grid>
        </Paper>
      )}
    </>
  );
}

export default Counters;
